"use client";

import Breadcrumb, { type BreadcrumbPath } from "@/app/components/breadcrumb.client";
import { useAuth } from "@/context/authcontext";

interface BreadcrumbClientProps {
    label: string;
}

export default function BreadcrumbClient({ label }: BreadcrumbClientProps) {
    const { isAuthenticated } = useAuth();

    return (
        <Breadcrumb
            paths={
                [
                    { label: "Home", route: isAuthenticated ? "/platform" : "/" },
                    isAuthenticated
                        ? { label: "Unlisted Shares", href: `${process.env.ICM_UE_POST_URL_LISTING}` }
                        : { label: "Unlisted Shares", route: `${process.env.ICM_UE_URL}` },
                    { label },
                ] as BreadcrumbPath[]
            }
        />
    );
}
